import {Component, EventEmitter, Output} from '@angular/core';
import {LanguageEnum} from '../../../../../../../../core/enums/language.enum';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-custom-use-cases',
    templateUrl: './custom-use-cases.component.html',
    styleUrls: ['./custom-use-cases.component.scss']
})
export class CustomUseCasesComponent {

    @Output() myUseCaseEvent = new EventEmitter<void>();
    showInGerman = true;

    constructor(private route: ActivatedRoute) {
        this.route.queryParamMap.subscribe(params => {
            const language = params.get('l') as LanguageEnum;
            this.showInGerman = language === LanguageEnum.GERMAN;
        });
    }
}
